import { z } from 'zod';

import { Email } from './user';

export const AdminListWithdrawalReview = z.object({
	id: z.number(),
	decision: z.enum(['PENDING', 'APPROVED', 'DENIED']),
	amount: z.object({
		value: z.number(),
		text: z.string(),
	}),
	user: z.object({
		id: z.number(),
		email: z.string(),
	}),
	handledByAdmin: z
		.object({
			id: z.number(),
			email: Email,
		})
		.nullable(),
	reasonMessage: z.string().nullable(),
	createdAt: z.date(),
	updatedAt: z.date(),
});
export type AdminListWithdrawalReview = z.infer<typeof AdminListWithdrawalReview>;

export const AdminSingleWithdrawalReview = AdminListWithdrawalReview.extend({});
export type AdminSingleWithdrawalReview = z.infer<typeof AdminSingleWithdrawalReview>;
